/**
 * Cloudflare Web Analytics — the cookieless, no-consent counterpart to GA. It stores
 * nothing on the device (privacy-first), so it loads on the public site without a consent
 * gate. (Search-engine ownership is handled via DNS-TXT verification, not code.)
 */

const CF_ATTR = 'data-cf-wa';

/** Inject the Cloudflare Web Analytics beacon. Idempotent. */
export function loadCloudflareWA(token: string): void {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[${CF_ATTR}]`)) return;
  const s = document.createElement('script');
  s.defer = true;
  s.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  // Expose cross-origin script errors to window.onerror (and thus PostHog
  // Error Tracking) instead of the scrubbed "Script error." blank.
  s.crossOrigin = 'anonymous';
  // Cloudflare WA auto-tracks SPA navigations via the History API.
  s.setAttribute('data-cf-beacon', JSON.stringify({ token }));
  s.setAttribute(CF_ATTR, '1');
  document.head.appendChild(s);
}

export function unloadCloudflareWA(): void {
  if (typeof document === 'undefined') return;
  document.querySelectorAll(`script[${CF_ATTR}]`).forEach((el) => el.remove());
}
